<script>
import FormGroup from "@/components/molecules/form-group";
import Button from "@/components/atoms/button";
import FormInput from "@/components/molecules/form-input";
import Form from "@/components/molecules/form";
import StateOverlay from "@/components/molecules/state-overlay";
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";
import FormError from "@/components/molecules/form/form-error";

export default {
  name: "PaymentMethodCodePromo",
  components: {
    FormInput,
    FormGroup,
    Form,
    Button,
    StateOverlay,
    FormError
  },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    discountMultipayError: {
      type: Boolean,
      required: false,
      default: false
    },
    error: {
      type: Object,
      required: false,
      default: null
    },
    ...formValidationProps()
  },
  emits: ["applyCodePromo"],
  setup(props) {
    const { v$, getState, getErrorMessage, isSuccess } =
      useFormValidation(props);
    return {
      v$,
      getState,
      getErrorMessage,
      isSuccess
    };
  },
  computed: {
    success() {
      if (this.isSuccess && !this.isRetry) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      code_promo: "",
      isRetry: false
    };
  },
  methods: {
    applyCodePromo() {
      this.$emit("applyCodePromo", this.code_promo);
      this.isRetry = false;
    },
    retry() {
      this.isRetry = true;
    }
  }
};
</script>

<template>
  <div class="c-payment-method-promo-code">
    <StateOverlay
      :is-loading="isLoading"
      vertical-align
      overlay
      loading-spinner-size="xs"
      message="Nous vérifions le code promo"
      class="u-full-height"
    >
      <div class="c-payment-method-promo-code__content">
        <p class="u-font-secondary u-font-18 u-font-700">
          J'utilise un code promo
        </p>
        <Form
          class="u-flex u-flex-align-start"
          @submit.prevent="applyCodePromo"
        >
          <div class="c-payment-method-promo-code__form">
            <FormGroup
              :state="success ? 'success' : getState(v$,'code_promo')"
              size="xlg"
              class="c-payment-method-promo-code__input"
            >
              <FormInput
                v-model="code_promo"
                :state="success ? 'success' : getState(v$,'code_promo')"
                :disabled="success"
                size="sm"
              >
                Code promo
              </FormInput>
              <template #message>
                <p class="u-font-14">
                  {{ getErrorMessage('code_promo',"Code promo invalide") }}
                </p>
              </template>
            </FormGroup>
            <Button
              v-if="!success"
              size="sm"
              outline
              radius="full"
              variant="primary"
              type="submit"
              :disabled="code_promo === ''"
              value="Valider mon code"
            />
            <Button
              v-else
              link
              @click="retry()"
            >
              Je change de code
            </Button>
          </div>
        </Form>
        <FormError
          v-if="error && error.message && (!error.errors || !error.errors.code_promo)"
          :error="{ message : error.message }"
          class="u-text-center"
        />
      </div>
    </StateOverlay>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/payment-method-promo-code.scss";
</style>
